export const page3Labels:any={
    aboutPromiseSectionHeading:"About Promises Section Heading*",
    aboutPromiseDescription:"About Promises Promise Description*",
    promiseSectionHeading:"Promise Section Heading",
    disclaimer:"Disclaimer*",
    isDisclaimerActive:"Disclaimer Toggle"
}